import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PolitiqueConfidentialitePage() {
  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      <Navbar />

      <section className="pt-32 pb-16 bg-[#1a2e4a]">
        <div className="max-w-6xl mx-auto px-6">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-white/40 mb-4">Mentions légales</p>
          <h1 className="text-4xl font-light text-white leading-tight tracking-tight">
            Politique de <span className="font-semibold">confidentialité</span>
          </h1>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-6">
          <div className="text-gray-600 leading-relaxed">

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">1. Responsable du traitement</h2>
              <div className="bg-[#f5f4f2] rounded-lg p-5 text-sm">
                <p><strong>BONIEK</strong> – Dominika Julia Boniek</p>
                <p>27 Rue Malbec, 33800 Bordeaux, France</p>
                <p>Email : dom1n1kaboniek@outlook.com</p>
              </div>
            </div>

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">2. Données collectées</h2>
              <p className="text-sm leading-relaxed mb-4">
                Dans le cadre de l&apos;utilisation du formulaire de contact, le site peut collecter les données personnelles suivantes :
              </p>
              <ul className="list-none flex flex-col gap-2">
                {['Nom et prénom', 'Adresse email', 'Numéro de téléphone', 'Contenu du message'].map((item) => (
                  <li key={item} className="flex items-center gap-3 text-sm text-gray-600">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-[#1a2e4a]/10 shrink-0">
                      <i className="ri-check-line text-[#1a2e4a] text-xs"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">3. Finalité du traitement</h2>
              <p className="text-sm leading-relaxed">
                Les données collectées sont utilisées uniquement pour répondre aux demandes de contact et d&apos;information formulées par les utilisateurs. Elles ne font l&apos;objet d&apos;aucun traitement commercial.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">4. Conservation des données</h2>
              <p className="text-sm leading-relaxed">
                Les données sont conservées le temps nécessaire au traitement de la demande, puis supprimées conformément aux obligations légales en vigueur.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">5. Partage des données</h2>
              <p className="text-sm leading-relaxed">
                Les données personnelles collectées ne sont ni vendues, ni cédées, ni partagées avec des tiers à des fins commerciales. Elles restent strictement confidentielles.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">6. Vos droits</h2>
              <p className="text-sm leading-relaxed mb-3">
                Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
              </p>
              <ul className="list-none flex flex-col gap-2 mb-4">
                {[
                  'Droit d\'accès à vos données',
                  'Droit de rectification',
                  'Droit à l\'effacement',
                  'Droit à la limitation du traitement',
                  'Droit d\'opposition',
                ].map((item) => (
                  <li key={item} className="flex items-center gap-3 text-sm text-gray-600">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-[#1a2e4a]/10 shrink-0">
                      <i className="ri-check-line text-[#1a2e4a] text-xs"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-sm leading-relaxed">
                Pour exercer ces droits, contactez-nous à :{' '}
                <a href="mailto:dom1n1kaboniek@outlook.com" className="text-[#1a2e4a] hover:underline cursor-pointer">
                  dom1n1kaboniek@outlook.com
                </a>
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-lg font-semibold text-[#1a2e4a] mb-4">7. Cookies</h2>
              <p className="text-sm leading-relaxed">
                Ce site n&apos;utilise pas de cookies de traçage ou de publicité. Des cookies techniques essentiels au fonctionnement du site peuvent être utilisés.
              </p>
            </div>

            <p className="text-xs text-gray-400 mt-12 pt-6 border-t border-gray-100">
              Dernière mise à jour : avril 2026
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
